import { Button, makeStyles } from '@material-ui/core';
import axios from 'axios';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { 
  findDeepPath, formatDate, formatNum, getDateEx, getLodingStatus, 
  makeUrlSearchParams, null2Zero, parseDate 
} from '../../commonModule';
import { setBillInfoToSch } from '../Billing/blMakeData';
import { LoadingSpinner } from '../common/commonParts';
import SnackMsg from '../common/SnackMsg';

const useStyles = makeStyles({
  button: {margin: 8}
})

const str2gdex = (s) =>{
  return getDateEx(s.split('-')[0], s.split('-')[1], s.split('-')[2]);
}

const getReportsDate = (dateName, stdDate, bDt, schedule) => {
  const tDate = parseDate(stdDate).date.dt;
  const nDate = new Date(tDate.getFullYear(), tDate.getMonth() + 2, 12);
  const jtInit = formatDate(nDate, 'YYYY-MM-DD');
  const jtDate =
    (findDeepPath(schedule, ['report', bDt.service, dateName])) ? 
    schedule.report[bDt.service][dateName] : jtInit;
  const gengou = str2gdex(jtDate).wr.l; // 元号
  const wry = String(str2gdex(jtDate).wr.y).padStart(2, '0'); // 和暦の年
  const month = String(str2gdex(jtDate).m).padStart(2, "0");
  const day = String(str2gdex(jtDate).d).padStart(2, '0');

  return`${gengou}${wry}年${month}月${day}日`;
}

const getBillingDt = (allState, loadingStatus) => {
  if(!loadingStatus.loaded) return false;
  const {stdDate, schedule, users, com, service, serviceItems} = allState;
  const bits_prms = {stdDate, schedule, users, com, service, serviceItems}
  const {billingDt} = setBillInfoToSch(bits_prms);

  return billingDt
}

const sendContacts = async(allState, sendDt, setSnack) => {
  const {hid, bid, stdDate} = allState;
  const parms = {a: "sendPartOfContact", hid, bid, date: stdDate, partOfContact: JSON.stringify(sendDt)};
  const res = await axios.post("https://houday.rbatos.com/api/apidev.php", makeUrlSearchParams(parms));
  if(!res.data.result) setSnack({...{msg: '書き込みに失敗しました。', severity: 'warning'}});
  else{
    setSnack({...{msg: '書き込み完了しました。', id: new Date().getTime()}});
  }
}

const handleClick = async(allState, addDtList, dtName, setSnack) => {
  const {hid, bid, stdDate} = allState;
  const parms = {a: "fetchContacts", hid, bid, date: stdDate};
  const res = await axios.post("https://houday.rbatos.com/api/apidev.php", makeUrlSearchParams(parms));
  if(!res.data.result) {
    setSnack({...{msg: 'データの取得に失敗しました。', severity: 'warning'}});
    return false;
  }
  const contacts = findDeepPath(res.data.dt[0], ["contacts"], {});
  const send_dt = addDtList.reduce((result, addDt) => {
    const this_user_contacts = contacts[addDt.UID] ?contacts[addDt.UID] :{};
    const data = {...this_user_contacts};
    data[dtName] = addDt[dtName];
    result[addDt.UID] = data;
    return result
  }, {});
  sendContacts(allState, send_dt, setSnack);
}

export const AddBillingDtButton = () => {
  const classes = useStyles();
  const allState = useSelector(state => state);
  const loadingStatus = getLodingStatus(allState);
  const [snack, setSnack] = useState({});
  if(!loadingStatus.loaded) return <LoadingSpinner />;
  const {stdDate, schedule} = allState;
  const billing_dts = getBillingDt(allState, loadingStatus);
  const add_dt = billing_dts.map(bDt => {
    const billing = [];
    const futangaku = bDt.kanrikekkagaku - null2Zero(bDt.kanrikekkagaku);
    const num = 1;
    let total_price = 0;
    const price = formatNum(futangaku, 1) * num;
    billing.push({"利用者負担額": futangaku, num, price});
    total_price += price;
    const actualcost_list = bDt.actualCostDetail.map(actualCostDt => {
      const data = {};
      data[actualCostDt.name] = actualCostDt.unitPrice;
      data["num"] = actualCostDt.count;
      data["price"] = actualCostDt.price;
      total_price += actualCostDt.price;
      return data;
    });
    billing.push(...actualcost_list);
    billing.push({"請求日": getReportsDate("請求書受領書", stdDate, bDt, schedule)});
    billing.push({"合計": total_price});
    return {UID: bDt.UID, billing}
  })

  return(
    <>
    <Button
      className={classes.button}
      variant='contained'
      color="primary"
      onClick={() => handleClick(allState, add_dt, "billing", setSnack)}
    >
      売上データ追加
    </Button>
    <SnackMsg {...snack}/>
    </>
  )
}

export const AddDairijuryouDtButton = () => {
  const classes = useStyles();
  const allState = useSelector(state => state);
  const loadingStatus = getLodingStatus(allState);
  const [snack, setSnack] = useState({});
  if(!loadingStatus.loaded) return <LoadingSpinner />;
  const billing_dts = getBillingDt(allState, loadingStatus);
  const {stdDate, schedule, users} = allState;
  const add_dt = billing_dts.map(bDt => {
    const dairijuryou = [];
    const gengou = str2gdex(stdDate).wr.l; // 元号
    const wry = String(str2gdex(stdDate).wr.y).padStart(2, '0'); // 和暦の年
    const month = String(str2gdex(stdDate).m).padStart(2, "0");
    dairijuryou.push({"サービス提供月": `${gengou}${wry}年${month}月`});
    dairijuryou.push({"サービス種別": bDt.service});
    dairijuryou.push({"総費用額": String(bDt.userSanteiTotal)});
    dairijuryou.push({"利用者負担": String(bDt.ketteigaku)});
    const c_price = "0";
    const dairiJuryo_price = parseInt(bDt.userSanteiTotal) - parseInt(bDt.ketteigaku) + parseInt(c_price);
    dairijuryou.push({"代理受領金額": String(dairiJuryo_price)});
    // dairijuryou.push({"受領日": `${gengou}${wry}年${month}月${day}日`});
    dairijuryou.push({"受領日": getReportsDate("代理受領通知日", stdDate, bDt, schedule)});
    const s_city = users.find(userDt => userDt.uid === bDt.UID.replace("UID", "")).scity;
    const note = `${bDt.name}様に提供した下記のサービスに要した費用について、${s_city}から下記のとおり利用者様に代わり支払いを受けましたので、お知らせします。このお知らせの内容に疑義がある場合は、当事業所もしくは${s_city}にお問い合わせください。`
    dairijuryou.push({"note": note});
    return {UID: bDt.UID, dairijuryou}
  })

  return(
    <>
    <Button
      className={classes.button}
      variant='contained'
      color="primary"
      onClick={() => handleClick(allState, add_dt, "dairijuryou", setSnack)}
    >
      受領データ追加
    </Button>
    <SnackMsg {...snack}/>
    </>
  )
}

export const AddReceiptDtButton = () => {
  const classes = useStyles();
  const allState = useSelector(state => state);
  const loadingStatus = getLodingStatus(allState);
  const [snack, setSnack] = useState({});
  if(!loadingStatus.loaded) return <LoadingSpinner />;
  const billing_dts = getBillingDt(allState, loadingStatus);
  const {stdDate, schedule} = allState;
  const add_dt = billing_dts.map(bDt => {
    const receipt = [];
    const futangaku = bDt.kanrikekkagaku - null2Zero(bDt.kanrikekkagaku);
    const num = 1;
    let total_price = 0;
    const price = formatNum(futangaku, 1) * num;
    receipt.push({"利用者負担額": futangaku, num, price});
    total_price += price;
    const actualcost_list = bDt.actualCostDetail.map(actualCostDt => {
      const data = {};
      data[actualCostDt.name] = actualCostDt.unitPrice;
      data["num"] = actualCostDt.count;
      data["price"] = actualCostDt.price;
      total_price += actualCostDt.price;
      return data;
    });
    receipt.push(...actualcost_list);
    receipt.push({"受領日": getReportsDate("請求書受領書", stdDate, bDt, schedule)});
    receipt.push({"合計": total_price});
    return {UID: bDt.UID, receipt}
  })

  return(
    <>
    <Button
      className={classes.button}
      variant='contained'
      color="primary"
      onClick={() => handleClick(allState, add_dt, "receipt", setSnack)}
    >
      レシートデータ追加
    </Button>
    <SnackMsg {...snack}/>
    </>
  )
}